import React, { useState, useEffect, useRef } from "react";
// import { acceptOrder, rejectOrder } from "../utils/api";
import Tone from "../../shared/components/tone.mp3";
import { FaStoreAlt, FaTruck, FaTimes, FaUser } from "react-icons/fa";
// import areakartLogo from "../../assets/images/logo/areakartLogo.png";
import RiderCancel from "../../shared/components/riderCancel.wav";

const OrderToast = ({ order, closeToast }) => {
  const audioRef = useRef(null); // Use ref for better control
  const [audioStarted, setAudioStarted] = useState(false);
  const { eventType, orderId, message, jsonString } = order || {};
  const orderData = jsonString ? JSON.parse(jsonString) : {};
  useEffect(() => {
    const audio = new Audio(eventType === "NEW_ORDER" ? Tone : RiderCancel);
    audio.loop = true; // 🔁 Loop audio
    audio.play();
    audioRef.current = audio;

    audio
      .play()
      .then(() => {
        setAudioStarted(true);
      })
      .catch((err) => {
        console.warn("Autoplay failed (waiting for user interaction)", err);
      });

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [eventType]);

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const handleView = (e) => {
    stopAudio();
    closeToast();
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="popup-close" onClick={closeToast}>
          <FaTimes />
        </button>
        <h2 className="popup-heading">{message}</h2>
        <div className="order-details">
          <div className="detail-row">
            <FaStoreAlt className="text-gray-400" />
            <span>Store: {orderData.storeName}</span>
          </div>
          <div className="detail-row">
            <FaUser className="text-gray-400" />
            <span>Customer: {orderData.customerName}</span>
          </div>
          <div className="detail-row">
            <FaTruck className="text-gray-400" />
            <span>Order Type: {orderData.orderType}</span>
          </div>
        </div>
        <div className="flex justify-center">
          <button className="view-button" onClick={handleView}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderToast;
